import { Fragment, Suspense, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Outlet, useParams } from 'react-router'
import cx from 'classnames'

import { selectIsLoggedIn } from 'store/selectors'
import usePageModal from 'features/Modal/hooks/usePageModal'
import { MODAL_MODE } from 'components/Modal/config'
import { useIsSelfUser } from './lib/useIsSelfUser'
import { useGetUserQuery } from 'store/api/yay/user'
import { st } from 'lib/helpers'

import MutualFollowing from 'features/MutualFollowing'
import RecommendedUser from './components/RecommendedUsers'
import UserActions from './components/UserActions'
import UserActiveCallPopup from './components/UserActiveCallPopup'
import UserInfo from './components/UserInfo'
import UserWallpaper from './components/UserWallpaper'
import SeoHeader from 'components/SEOHeader'
import UserFollowerModal from 'pages/UserFollowerModal'
import UserFollowingModal from 'pages/UserFollowingModal'

const User = () => {
  const params = useParams()
  const { generatePageModalUrl } = usePageModal()
  const userId = Number(params.userId)
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const [isUserRecommendedSectionActive, setIsUserRecommendedSectionActive] =
    useState(false)
  const userRes = useGetUserQuery({
    userId: userId?.toString?.(),
  })
  const isSelfUser = useIsSelfUser(userId)

  useEffect(() => {
    setIsUserRecommendedSectionActive(false)
  }, [userId])

  const createLetterModalLink = generatePageModalUrl(
    MODAL_MODE.CREATE_USER_REVIEW,
    { userId: userRes?.data?.id }
  )

  return (
    <Fragment>
      <SeoHeader
        description={st(`user.description`, {
          user_bio: userRes?.data?.biography,
        })}
        title={st(`user.title`, {
          username: userRes?.data?.nickname,
        })}
      />
      <div className="Box Box--mobile-bdb">
        <div className="User">
          <UserWallpaper userId={userId} />
          <div className="User__profile">
            <UserActions
              createLetterModalLink={createLetterModalLink}
              followCallback={() => {
                setIsUserRecommendedSectionActive(true)
              }}
            />
            <UserInfo />
            <RecommendedUser
              onClose={() => setIsUserRecommendedSectionActive(false)}
              isActive={isUserRecommendedSectionActive}
              userId={userId}
            />
            {isLoggedIn && !isSelfUser && <MutualFollowing userId={userId} />}
          </div>
        </div>
        <Suspense fallback={<div />}>
          <Outlet />
        </Suspense>
      </div>
      <UserActiveCallPopup userId={userId} />
      <Fragment>
        <UserFollowerModal />
        {isSelfUser && <UserFollowingModal />}
      </Fragment>
    </Fragment>
  )
}

export default User
